//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";



//-------------------------------------------------------------------------------------------------- Interfaces
export interface LoadingSliceInterface {
    isLoading: boolean;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const loadingSliceInitialState = {
    isLoading: false
} as LoadingSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const loadingSlice = createSlice({
    name: "loading",
    initialState: loadingSliceInitialState,
    reducers: {
        setLoading: (state, action: PayloadAction<LoadingSliceInterface>) => {
            state.isLoading = action.payload.isLoading;
        },
        clearLoading: (state) => {
            state.isLoading = loadingSliceInitialState.isLoading;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const {setLoading, clearLoading} = loadingSlice.actions;
export const getLoading = (state: any) => state.loading;
export default loadingSlice.reducer;
